import api from "../../../utils/apiService";
import { ENDPOINT } from "../../../config/endpoints";

/**
 * Uplifted from `redux-store/saga/localServer` (apps/web 99 lines, apps/mobile 102).
 *
 * The LAN sync sagas: one terminal acts as master and the others sync sales through it.
 *
 * A SPLIT. Two of the five workers are byte-identical and live here; three diverge, and two of
 * those three are REAL behavioural differences rather than style:
 *
 * | worker | shape |
 * |---|---|
 * | `callSyncStartApi` | identical -> here |
 * | `callSyncStopApi` | identical -> here |
 * | `callLocalMasterAPi` | DIVERGENT — one platform surfaces the error, the other has those
 *   lines commented out in the app source |
 * | `callSaleSyncProcess` | 🔴 DIVERGENT — one platform invokes the caller's callback with a
 *   generic error code on failure; the other leaves the caller with NO callback at all |
 * | `fetchServerSale` | 🔴 DIVERGENT — **the two platforms use different HTTP METHODS** |
 *
 * `root` stays per-variant: both apps watch the same five actions in the same order, but it
 * binds each platform's own workers. Same treatment as `saga/discount` / `saga/printer`.
 *
 * ⚠️ Two phantom imports were dropped under rule 2(b), and one of them RETIRES A RECORDED
 * BLOCKER: the ledger's session-22 census listed web's `localServer` as gated on
 * `sentryHelpers.sendCaptureEvent` ("genuinely app-coupled, not a move"). That import is
 * referenced ONLY on two COMMENTED-OUT lines of the app file, so it never blocked anything. The
 * other phantom is the other platform's `getMasterDomain`.
 *
 * ⚠️ Bare folder imports are REQUIRED in a `shared.ts` (hazard 16) — this file runs on both
 * platforms and must let the bundler pick each variant.
 */

/** Ask the master terminal to open a sync session. Identical in both apps. */
export function* callSyncStartApi(action: any): Generator<any, void, any> {
  let payload = action.payload;
  try {
    const response = yield api.request({
      method: "POST",
      data: payload.data,
      url: ENDPOINT.SALESYNC.startSync(),
    });
    payload.callback(response);
  } catch (error) {
    console.log("error", error);
  }
}

/**
 * Close the sync session. Identical in both apps.
 *
 * ⚠️ Note it reads `payload.dataToSend` where `callSyncStartApi` reads `payload.data`, and calls
 * `payload.callback()` with NO argument. Both are the apps' own; preserved verbatim.
 */
export function* callSyncStopApi(action: any): Generator<any, void, any> {
  let payload = action.payload;
  try {
    const response = yield api.request({
      method: "POST",
      data: payload.dataToSend,
      url: ENDPOINT.SALESYNC.stopSync(),
    });
    payload.callback();
  } catch (error) {
    console.log("error", error);
  }
}
